import { ChangeDetectorRef, NgZone, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { CalendarPipe } from 'angular2-moment';

@Pipe({
  name: 'mcCalendar'
})
export class McCalendarPipe implements PipeTransform {
  calendar: CalendarPipe;

  constructor(crd: ChangeDetectorRef, zone: NgZone) {
    this.calendar = new CalendarPipe(crd, zone);
  }

  transform(value: any, args?: any): any {
    const m = moment(value);
    return m.isValid()
      ? this.calendar.transform(m)
      : ' - ';
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pipes/calendar.pipe.ts